import React, { useState, useEffect } from "react";
import {
    Container,
    Button
} from "reactstrap";
import { Route, Redirect } from 'react-router-dom';

import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';



const JitsiVDO = (props) => {

    const teleID = (props.match.params.teleID !== undefined) ? props.match.params.teleID : null;

    var moment = require('moment');
    require('moment/locale/th');

    const [clientHeight, setClientHeight] = useState('');
    const [tokSession, setSession] = useState('');
    const [tokToken, setToken] = useState('');
    const [sessionHelper, setSessionHelper] = useState(null);
    const [lineTrangskin, setLineTrangskin] = useState("");
    const [streams, setStreams] = useState([]);


    React.useEffect(() => {

        //('\'' + window.innerHeight + 'px\'');

        if ((props.match.path.includes("/call")) ) {
            fetch('/api/v1/tele/session2/' + teleID, {
                method: 'GET',
                //headers: authHeader()
            })
                .then(handleResponse)
                .then(
                    (result) => {
                        window.location.href = 'https://meet.trangskin.go.th/' + teleID + '?jwt=' + result.token +'#config.disableDeepLinking=true';
                        //window.open('https://meet.trangskin.go.th/' + teleID +'#config.disableDeepLinking=true', 'Data', 'fullscreen=yes');
                        //setSession(result.tokSession)
                        //setToken(result.tokToken)
                    },
                    (error) => {
                        alert(error)
                        window.location.assign('/login');
                    }
                ); 
        }
        else if ((props.match.path.includes("/answer"))) {

            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/tele/answer2/' + teleID, requestOptions)
                .then(handleResponse)
                .then(
                    (result) => {
                        window.location.href = 'https://meet.trangskin.go.th/' + teleID + '?jwt=' + result.token + '#config.disableDeepLinking=true';

                    },
                    (error) => {
                        alert(error)
                        window.location.assign('/login');
                    }
                )

        }

        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }, []);



    return (
        <>
          
        </>
    );
}



export default JitsiVDO;
//export default preloadScript(AgoraVDO);
